import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LocationModel } from '../../../../locations/location.model';

@Component({
    selector: 'app-wizard-core-selection',
    templateUrl: './wizard-core-selection.component.html',
    styleUrls: ['./wizard-core-selection.component.scss'],
    standalone: false,
})
export class WizardCoreSelectionComponent implements OnInit {
    @Input() locationId: string;
    @Input() locationCore: LocationModel.LocationItem;
    @Input() selectedEdgeIds: string[] = [];
    @Output() coreSelected = new EventEmitter<string[]>();

    constructor() { }

    ngOnInit(): void { }

    public onEdgeSelected(edgeIds: string[]): void {
        this.coreSelected.emit(edgeIds);
    }
}
